
import NassauLogo from "./Media/nsre-logo.png";
import NassauLogoBlue from "./Media/nsre-logo-blue.png";
import InfoImage from "./Media/info.png";
import CheckImage from "./Media/check-sample.png";

import {
    faCalendar,
    faCheckCircle,
    faEnvelopeOpenText,
    faPencilAlt,
    faPhone, faQuestionCircle,
    faTrash
} from '@fortawesome/free-solid-svg-icons'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { faDollarSign } from '@fortawesome/free-solid-svg-icons'
import { faFileContract } from '@fortawesome/free-solid-svg-icons'
import { faIdCard } from '@fortawesome/free-solid-svg-icons'
import { faBirthdayCake } from '@fortawesome/free-solid-svg-icons'
import { faKey} from "@fortawesome/free-solid-svg-icons";
import { faPiggyBank} from "@fortawesome/free-solid-svg-icons";
import { faBars} from "@fortawesome/free-solid-svg-icons";
import { faMoneyCheck} from "@fortawesome/free-solid-svg-icons";
import { faCamera} from "@fortawesome/free-solid-svg-icons";

import MYGAStrings from "./Content/MYGAStrings";

let Resources = {

    Images : {

        Logo : NassauLogo,
        LogoBlue : NassauLogoBlue,
        Info : InfoImage,
        CheckImage: CheckImage

    },
    Icons : {

        EnvelopeOpenText : faEnvelopeOpenText,
        Search : faSearch,
        DollarSign : faDollarSign,
        FileContract : faFileContract,
        IdCard : faIdCard,
        BirthdayCake : faBirthdayCake,
        Key : faKey,
        PiggyBank : faPiggyBank,
        Bars : faBars,
        MoneyCheck : faMoneyCheck,
        Envelope : faEnvelopeOpenText,
        TrashCan: faTrash,
        Pencil: faPencilAlt,
        Check: faCheckCircle,
        Camera: faCamera,
        Calendar: faCalendar,
        Phone: faPhone,
        Questions: faQuestionCircle

    },
    CircleNumbers : {
        One : '①',
        Two : '②',
        Three : '③',
        Four : '④',
        Five : '⑤',
        Six : '⑥',

    },
    Strings : MYGAStrings,
    Urls : {
        PrivacyPolicy : 'privacy-consumer.html',
        TermsOfUse : 'terms-of-use-consumer.html'
    }

};

export default Resources;